<ng-container
  class="ticket-list"
  *ngIf="pagedTickets$ | glxyAsyncStatus | async as ticketList"
  [ngSwitch]="ticketList.status"
>
  <mat-chip-listbox hideSingleSelectionIndicator (change)="onStatusChange($event)">
    <mat-chip-option selected value="all" color="blue">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.STAGE.ALL' | translate }}
    </mat-chip-option>
    <mat-chip-option value="open" color="blue">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.STAGE.OPEN' | translate }}
    </mat-chip-option>
    <mat-chip-option value="closed" color="blue">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.STAGE.CLOSED' | translate }}
    </mat-chip-option>
  </mat-chip-listbox>
  <ng-container *ngSwitchCase="'loading'">
    <glxy-loading-spinner></glxy-loading-spinner>
  </ng-container>
  <ng-container *ngSwitchCase="'error'">
    <ng-container *ngTemplateOutlet="Error"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'loaded'">
    <glxy-loading-spinner *ngIf="isLoading$ | async"></glxy-loading-spinner>
    <ng-container *ngIf="(isLoading$ | async) === false">
      <ng-container *ngIf="ticketList.value.total === 0">
        <ng-container *ngTemplateOutlet="NoTickets"></ng-container>
      </ng-container>
      <ng-container *ngIf="ticketList.value.total > 0">
        <div class="ticket-card" *ngFor="let ticketInfo of ticketList.value.tickets">
          <app-support-ticket-card [ticketCardInfo]="ticketInfo"></app-support-ticket-card>
        </div>
      </ng-container>
      <div *ngIf="ticketList.value.continue">
        <button (click)="view5More()" color="primary" class="view-more">
          + {{ 'CRM.ASSOCIATION_PANEL.TICKETS.ACTIONS.SHOW_5_MORE' | translate }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #NoTickets>
    <mat-card class="no-results">
      <mat-card-content>
        {{ 'CRM.ASSOCIATION_PANEL.TICKETS.NO_TICKETS' | translate }}
      </mat-card-content>
    </mat-card>
  </ng-template>
  <ng-template #Error>
    <glxy-alert type="warning">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.ERROR_TICKETS' | translate }}
    </glxy-alert>
  </ng-template>
</ng-container>
